import { render, staticRenderFns } from "./InquiryList.vue?vue&type=template&id=605cfd5f&"
import script from "./InquiryList.vue?vue&type=script&lang=js&"
export * from "./InquiryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports